
var simple_sources = ["coal","natural gas","petroleum","nuclear","solar/pv","biomass","wind","hydroelectric","geothermal"]
var sources = simple_sources.map((i)=>{return "primary " + i})
var simple_sectors = ["commercial","government","industrial","residential","transportation"]
var sectors = simple_sectors.map( (i)=>{return i+" sector"})
var overheads = simple_sources.map((i)=>{return i+"_overhead"})

export default{
  simple_sources, sources, simple_sectors, sectors, overheads
}



//////////////////
// WEBPACK FOOTER
// ./src/globals.js
// module id = null
// module chunks = 